import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { Transition } from '../../../components/Transition';

interface IProps {
  toggle: boolean;
  secret: string;
  publicKey: string;
  onClose: () => void;
}

const SecretOnceDialog: React.FC<IProps> = ({
  toggle,
  secret,
  publicKey,
  onClose,
}) => {
  const copy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (error) {}
  };

  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      onClose={onClose}
    >
      <DialogTitle>Save this secret now</DialogTitle>
      <DialogContent dividers>
        <Typography
          variant='body2'
          sx={{ mb: 2 }}
        >
          The secret is shown only once. After you close this, it cannot be
          retrieved.
        </Typography>
        <TextField
          label='Key id'
          fullWidth
          value={publicKey}
          sx={{ mb: 2 }}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label='Secret'
          fullWidth
          value={secret}
          InputProps={{ readOnly: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => copy(publicKey)}>Copy key id</Button>
        <Button onClick={() => copy(secret)}>Copy secret</Button>
        <Button
          variant='contained'
          onClick={onClose}
        >
          I saved it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecretOnceDialog;
